import React, { useEffect, FC, useState } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { Carousel, message } from "antd";

import "./index.less";
import axios from "@/axios/axios";
import http from "@/fetch/fetch";

const contentStyle = {
  height: "420px",
  width: "1150px",
};

const MainPage: FC<any> = ({ history }) => {
  // banner 列表
  const [bannerList, setBannerList] = useState([]);
  const getBanner = async () => {
    const { code, data, msg }: any = await axios.post(
      "/shop/api/continuing/indexBannerList"
    );
    if (code === 0) {
      setBannerList(data || []);
    } else {
      message.error(msg);
    }
  };

  // 推荐课程 列表
  const [recommendList, setRecommendList] = useState([]);
  const getRecommend = async () => {
    const body = {
      currentPage: 1,
      pageSize: 4,
    };
    const { code, data, msg }: any = await http.post(
      "/shop/front/ce/item/recommend/list",
      body
    );
    if (code === 0) {
      const continuingEducationCourseList =
        data && data.continuingEducationCourseList;
      setRecommendList(continuingEducationCourseList);
    } else {
      message.error(msg);
    }
  };

  useEffect(() => {
    getBanner();
    getRecommend();
  }, []);

  const jump = (data: any) => {
    // history.push({pathname:'/index/subject',state:{ id: data.courseId}})
    history.push({ pathname: `/index/subject/${data.id}` });
  };

  const imgJump = (data: any) => {
    if (data.moreUrl) {
      window.open(data.moreUrl);
    }
  };

  return (
    <div className={"main-page"}>
      <div className={"content-banner"}>
        <div style={{ width: "1150px", margin: "0 auto" }}>
          <Carousel autoplay={true}>
            {bannerList.map((banner: any, i) => (
              <div key={i}>
                <div style={contentStyle}>
                  <img
                    onClick={() => {
                      imgJump(banner);
                    }}
                    style={{ width: "100%", height: "100%" }}
                    src={banner.allPathLink}
                    alt=""
                  />
                </div>
              </div>
            ))}
          </Carousel>
        </div>
      </div>
      <div className={"content-course"}>
        <div className={"content-course-box"}>
          <div className={"content-course-title"}>
            <p style={{ textAlign: "center", color: "#2a82e4" }}>推荐项目</p>
          </div>
          <div className={"content-course-list"}>
            {recommendList.map((recommend: any, i) => (
              <div
                key={i}
                className={"content-course-item"}
                onClick={() => {
                  jump(recommend);
                }}
              >
                <div className={"item-img"}>
                  <img src={recommend.coursePicture} alt="" />
                </div>
                <div className={"item-text"}>
                  <div className={"p-box"}>
                    <p>{recommend.courseName}</p>
                  </div>
                  <div className={"item-text-time"}>
                    <span className={"left"}>{recommend.creditInfo}</span>
                    <span className={"right"}>{recommend.classHour}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect((state) => state)(MainPage);
